export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/auth/login",
    REGISTER: "/auth/register",
    REFRESH: "/auth/refresh",
    LOGOUT: "/auth/logout",
  },
  USERS: "/users",
  ORGANIZATIONS: "/organizations",
  COMPETITIONS: "/competitions",
  TEAMS: "/teams",
} as const;

export const TOKEN_EXPIRATION = {
  ACCESS: "15m",
  REFRESH: "7d",
} as const;

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 20,
  MAX_LIMIT: 100,
} as const;

/**
 * Feature flag : Forfait 80€/mois organisateur.
 * false = offre masquée au lancement (Commission Partenaire uniquement).
 * Remettre à true pour réactiver l'offre Forfait.
 */
export const FORFAIT_ENABLED = true as const;

/** Tarifs Joueur Plus — TTC (Stripe Tax inclusive) */
export const JOUEUR_PLUS_MONTHLY_TTC_CENTS = 200 as const; // 2 € TTC/mois
export const JOUEUR_PLUS_ANNUAL_TTC_CENTS = 2_000 as const; // 20 € TTC/an (2 mois offerts)

/** Tarifs Club Pro — TTC (Stripe Tax inclusive) */
export const CLUB_PRO_MONTHLY_TTC_CENTS = 2_000 as const; // 20 € TTC/mois
export const CLUB_PRO_ANNUAL_TTC_CENTS = 20_000 as const; // 200 € TTC/an (2 mois offerts)

/** Tarifs Forfait Organisateur — TTC (Stripe Tax inclusive) */
export const ORGA_FORFAIT_MONTHLY_TTC_CENTS = 8_000 as const; // 80 € TTC/mois
export const ORGA_FORFAIT_ANNUAL_TTC_CENTS = 80_000 as const; // 800 € TTC/an (2 mois offerts)

/** Helpers formatage prix cents → euros */
export const centsToEuros = (cents: number): number => cents / 100;
export const formatPriceTTC = (cents: number): string =>
  `${centsToEuros(cents).toFixed(cents % 100 === 0 ? 0 : 2)} €`;

/** Commission Partenaire — taux en basis points (2 % = 200 bps) */
export const COMMISSION_RATE_BPS = 200 as const;
/** Commission Partenaire — part fixe par inscription (0,30 €) */
export const COMMISSION_FIXED_FEE_CENTS = 30 as const;
/** Commission Partenaire — plancher par inscription (0,75 €) */
export const COMMISSION_MIN_FEE_CENTS = 75 as const;
/** Prix minimum d'un concours payant (5 €) — 0 = gratuit reste autorisé */
export const MIN_PAID_COMPETITION_PRICE_CENTS = 500 as const;

/**
 * Quotas Commission Partenaire — concours **payants** par organisation.
 * Au-delà, l'organisateur doit basculer sur le Forfait.
 * Les concours gratuits (price <= 0) ne sont pas comptés.
 * Décompte basé sur la date de début du concours, fuseau Europe/Paris.
 */
export const COMMISSION_MONTHLY_LIMIT = 3 as const;
export const COMMISSION_YEARLY_LIMIT = 15 as const;
export const COMMISSION_QUOTA_TIMEZONE = "Europe/Paris" as const;
